module.exports = __webpack_public_path__ + "media/images/btn_download_stallionkeepers-dcf679ee768c069f26a1a2f855ca7969.gif";